var $ = require('jquery');

$(function () {
    $('.column-primary-cta').each(function () {
        var t = $(this);
        $(this).find('.column-primary-cta__see-more__more')[0].onclick = function () {
            t.toggleClass('show-more');
        }
        $(this).find('.column-primary-cta__see-more__less')[0].onclick = function () {
            t.toggleClass('show-more');
        }
        var list = t.find('.column-primary-cta__list');
        var listItems = list.children('.column-primary-cta__list__item');
        var maxColumns = list.data('max-columns');

        listItems.each(function () {
            for (var i = 0; i < listItems.length; i += maxColumns) {
                var noIcons = 0,
                    row = listItems.slice(i, i + maxColumns);

                row.each(function () {
                    if ($(this).children('.icon-in-circle.no-icon').length > 0) {
                        noIcons += 1;
                    }
                });

                if (noIcons === row.length) {
                    row.each(function () {
                        $(this).children('.icon-in-circle.no-icon').addClass('hide');
                    });
                }
            }
        });
    });
}); 
